import { TextFieldProps } from '@mui/material';
import { SecureTextField } from 'components/SecureTextField/SecureTextField';
import { TextField } from 'components/TextField/TextField';
import { LoginFormInputs } from 'features/auth';
import React from 'react';
import { Controller, Control, UseFormRegister, FieldValues } from 'react-hook-form';

type FormInputTextProps = TextFieldProps & {
  control: Control<LoginFormInputs>;
  name: 'email' | 'password' | 'forgotPassword';
  rules: any;
  secure?: boolean;
  id: string;
  shouldTrim?: boolean;
};

export const FormInputText: React.FC<FormInputTextProps> = ({
  control,
  name,
  rules,
  secure = false,
  shouldTrim = true,
  ...textFieldProps
}) => {
  const TextFieldComponent = secure ? SecureTextField : TextField;

  return (
    <Controller
      name={name}
      rules={rules}
      control={control}
      render={({ field: { onChange, onBlur, value }, fieldState: { error } }) => {
        const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
          const inputValue = e.target.value;
          onChange(shouldTrim ? inputValue.trim() : inputValue);
        };

        return (
          <TextFieldComponent
            {...textFieldProps}
            onChange={handleChange}
            onBlur={onBlur}
            value={value ?? ''}
            error={!!error}
            helperText={error?.message ?? null}
          />
        );
      }}
    />
  );
};
